var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 44C35.5 45.6569 34.1569 47 32.5 47C30.8431 47 29.5 45.6569 29.5 44C29.5 42.3431 30.8431 41 32.5 41C34.1569 41 35.5 42.3431 35.5 44Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 28V16C20.5 9.37258 25.8726 4 32.5 4C39.1274 4 44.5 9.37258 44.5 16V28H50.5C51.6046 28 52.5 28.8954 52.5 30V58C52.5 59.1046 51.6046 60 50.5 60H14.5C13.3954 60 12.5 59.1046 12.5 58V30C12.5 28.8954 13.3954 28 14.5 28H20.5ZM42.5 16V28H22.5V16C22.5 10.4772 26.9772 6 32.5 6C38.0228 6 42.5 10.4772 42.5 16ZM14.5 30V58H50.5V30H14.5Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.e132e3b5.svg";
export { ForwardRef as ReactComponent };